import decode from 'jwt-decode'
import router from '../router'
// import http from '@/services/http'
import localforage from 'localforage'
import store from '@/store'

// import { mapActions } from 'vuex'

const ACCESS_TOKEN_KEY = 'token'

export function getAccessToken () {
  return localforage.getItem(ACCESS_TOKEN_KEY)
}

export async function isLoggedIn () {
  const accessToken = await localforage.getItem(ACCESS_TOKEN_KEY)
  return !!accessToken && !isTokenExpired(accessToken)
}

export function logout () {
  localforage.removeItem('new_current_user').then(() => {
    store.dispatch('removeNewCurrent', { root: true })
  })
  localforage.removeItem(ACCESS_TOKEN_KEY).then(() => {
    localforage.removeItem('new_current_user').then(() => {
      store.dispatch('removeNewCurrent', { root: true })
      localforage.removeItem('current_permissions').then(() => {
        router.push({ name: 'auth.login' })
      })
    })
  })
}

// mapActions(['setToken'])
//
// export async function login (email, password) {
//   const response = await http.post('/user_token', { auth: { email, password } })
//   const { jwt } = response.data
//
//   localforage.setItem('token', jwt).then((jwt) => {
//     debugger
//     this.setToken({ token: jwt })
//     router.push({ name: 'dashboard.index' })
//   })
// }

function getTokenExpirationDate (encodedToken) {
  const token = decode(encodedToken)
  if (!token.exp) { return null }

  const date = new Date(0)
  date.setUTCSeconds(token.exp)

  return date
}

function isTokenExpired (token) {
  const expirationDate = getTokenExpirationDate(token)
  return expirationDate < new Date()
}



// WEBPACK FOOTER //
// ./src/utils/auth.js